import React from "react";
import { useNavigate } from "react-router-dom";
import { Animate } from "react-simple-animate";
import "./styles.scss";
import { RiGithubFill, RiLinkedinFill, RiTwitterXFill } from "react-icons/ri";

const Home = () => {
  const navigate = useNavigate();

  const handleNavigateToContactMePage = () => {
    navigate("/contact");
  };

  return (
    <section id="home" className="home">
      <div className="home__text-wrapper">
        <h1 style={{ animation: "typingEffect 1s steps(30,end)" }}>
          Hello, I'm{" "}
          <em
            style={{
              color: "#fff",
              animation: "typingEffect 1s steps(30,end)",
            }}
          >
            amit giri
          </em>
          <br />
          FullStack developer
        </h1>
      </div>
      <Animate
        play
        duration={1.5}
        delay={1}
        start={{
          transform: "translateY(550px)",
        }}
        end={{
          transform: "translatex(0px)",
        }}
      >
        <div className="home__contact-me">
          <button onClick={handleNavigateToContactMePage}>Hire Me</button>
        </div>
        <div className="home__social">
          <a href="https://twitter.com/amit_XV">
            <RiTwitterXFill size={20} color="white" />
          </a>
          <a href="https://www.linkedin.com/in/amit-giri72/">
            <RiLinkedinFill size={20} color="white" />
          </a>
          <a href="https://github.com/amitgiri72">
            <RiGithubFill size={20} color="white" />
          </a>
        </div>
      </Animate>
    </section>
  );
};
export default Home;
